import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-vahan',
  templateUrl: './vahan.component.html',
  styleUrls: ['./vahan.component.scss']
})
export class VahanComponent implements OnInit {
  vahanData: any;
  sarathiData: any;

  constructor() { }

  ngOnInit() {
  }
  setVahanData(data: any, data1: any) {
    this.vahanData = {};
    this.sarathiData = {};
    this.vahanData = data;
    this.sarathiData = data1;
  }

}
